import React from 'react'
import { Card } from "react-bootstrap"
import Image from "next/image"

const IMG_CHARITY_LOGO: string = '/static/images/charity-logo.png'

const CharityStorageCard: React.FC = () => (
    <Card className="mb-3">
        <Card.Body className="d-flex flex-column align-items-center">
            <Card.Title className="text-center">
                <Image src={IMG_CHARITY_LOGO} alt="charity auction" width={171} height={91} />
                <h4><strong>Drop Off Point</strong></h4>
            </Card.Title>
            <Card.Text>
                Donate unneeded items & get a tax receipt! Charity Storage utilizes public storage auctions to raise money for charities nationwide. Facilities designate a unit to serve as a
                donation drop off point. The unit is sold at the auction & all the money goes to charity.
            </Card.Text>
            <div className="text-center">
                <a href="https://www.charitystorage.org" target="_blank" rel="noopener noreferrer">
                    <i className="fa fa-external-link-square" style={{ height: 22, width: 22 }} /> Learn More
                </a>
            </div>
        </Card.Body>
    </Card>
)

export default CharityStorageCard
